module.exports = __webpack_public_path__ + "img/25_49.15ee955f.png";